import { CdkTrapFocus } from '@angular/cdk/a11y';
import { Component, inject } from '@angular/core';
import { BaseComponent, DialogRef } from '@shared/classes';
import { ButtonComponent } from '@shared/components/button/button.component';
import {
  DIALOG_DATA,
  DialogConfig,
  TermsAndConditionsDialog,
} from '@shared/models';
import { SafePipe } from '@shared/pipes';

@Component({
  selector: 'b2c-terms-and-conditions-modal',
  styleUrl: './terms-and-conditions-modal.component.scss',
  templateUrl: './terms-and-conditions-modal.component.html',
  imports: [ButtonComponent, CdkTrapFocus, SafePipe],
})
export class TermsAndConditionsModalComponent extends BaseComponent {
  public config: TermsAndConditionsDialog = this.loyaltyChallengeConfig
    .components.modals.termsAndConditions as TermsAndConditionsDialog;

  protected readonly dialogData: DialogConfig =
    inject<DialogConfig>(DIALOG_DATA);

  public data: string = this.dialogData.data as string;

  private readonly dialogRef: DialogRef = inject(DialogRef);

  closeDialog(): void {
    this.dialogRef.close();
  }
}
